import React, { useState } from "react";
import { Alert, Col, Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import authApi from "../api/authApi";
import jwt_decode from 'jwt-decode';

const Login = () => {
  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const [show, setShow] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [activeMessage, setInactiveMessage] = useState();
  const [validated, setValidated] = useState(true);

  const checkRequiredFields = () => {
    return !(credentials.email.trim() && credentials.password.trim());
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      if (checkRequiredFields()) {
        setValidated(false);
        return;
      }

      const result = await authApi.login(credentials.email, credentials.password);
      if (result.success) {
        sessionStorage.setItem("token", result.authToken);
        const decodedToken = jwt_decode(sessionStorage.getItem('token'));
        
        if (decodedToken.isActive) {
          window.location.href = "/";
        } else {
          setErrorMessage(null);
          setInactiveMessage("User is InActive!");
          setShow(true);
        }
      } else {
        setShow(true);
        setErrorMessage(result.errors);
      }
    } catch (error) {
      console.log('server error: ' , error);
    }
  };

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };  

  return (
    <Container className="d-flex justify-content-center align-items-center full-height">
      <Row className="login-form p-3 mt-5">
        <Col lg={6} className="pt-5 login-side-logo">
          <img src="login.jpg" alt="login-image" className="img-fluid login-image" />
        </Col>
        <Col lg={6} xs={12} className="login-section">
          <div className="p-5 pt-4">
            <Form onSubmit={handleSubmit}>
              <div className="mt-2 text-center mb-3">
                <img src="srmlogo.jpg" className="mb-2 img-fluid srm-logo" alt="system-logo" />
                <div>Convert, before it fades away</div>
                <h3 className="my-2 mt-5">Login</h3>
              </div>

              {errorMessage ? ( <Alert variant="danger" show={show} className="error-alert">
                {errorMessage}
              </Alert>) : (<Alert variant="danger" show={show} className="error-alert">
                {activeMessage}
              </Alert>) }
             
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Email address</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  onChange={handleChange}
                  placeholder="Enter your email"
                  value={credentials.email}
                  style={validated ? { border: "1px solid #ced4da" } : { border: "1px solid tomato" }}
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  name="password"
                  onChange={handleChange}
                  placeholder="Enter password"
                  value={credentials.password}
                  style={validated ? { border: "1px solid #ced4da" } : { border: "1px solid tomato" }}
                />
              </Form.Group>

              <div className="d-flex align-items-center">
                <Button className="btn btn-lg w-100" variant="primary" type="submit">Login</Button>
              </div>
              <center className="mt-3">
                <strong>
                  <Link to="/forget-password" style={{ textDecoration: "none" }}>Forgot Password</Link>
                </strong>
              </center>
            </Form>
          </div>
        </Col>
        <Col>
          <div className="text-center">
            <div className="text-center mt-3"> Powered by</div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
